import React from "react";
import Select from "react-select";

export const FeeInfo = ({ formData, handleChange, setFormData }) => {
    // formData.member.contractPartnerInfo

    // 플랫폼 수수료: platformCommissionShareRate
    // 오더 수수료: orderCommissionRate
    // 청구율: chargeRate

    // 청구율 옵션 생성 (0% ~ 65%, 5% 단위)
    const chargeRateOptions = [];
    for (let i = 0; i <= 65; i += 5) {
        chargeRateOptions.push({
            value: i,
            label: `${i}%`,
        });
    }

    // 오더 수수료율 옵션 생성 (0% ~ 20%, 5% 단위)
    const orderCommissionOptions = [];
    for (let i = 0; i <= 20; i += 5) {
        orderCommissionOptions.push({
            value: i,
            label: `${i}%`,
        });
    }

    // 플랫폼 수수료율 옵션 생성 (0% ~ 100%, 1% 단위)
    const platformCommissionOptions = [];
    for (let i = 0; i <= 100; i++) {
        platformCommissionOptions.push({
            value: i,
            label: `${i}%`,
        });
    }

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>청구율</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={chargeRateOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="청구율 선택"
                            value={chargeRateOptions?.find((opt) => opt.value === formData?.member?.contractPartnerInfo?.chargeRate)}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    member: {
                                        ...prev.member,
                                        contractPartnerInfo: {
                                            ...prev.member.contractPartnerInfo,
                                            chargeRate: option.value,
                                        },
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>오더 수수료율</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={orderCommissionOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="오더 수수료율 선택"
                            value={orderCommissionOptions?.find(
                                (opt) => opt.value === formData?.member?.contractPartnerInfo?.orderCommissionRate
                            )}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    member: {
                                        ...prev.member,
                                        contractPartnerInfo: {
                                            ...prev.member.contractPartnerInfo,
                                            orderCommissionRate: option.value,
                                        },
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>플랫폼 수수료 쉐어</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            options={platformCommissionOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                            isSearchable={false}
                            placeholder="플랫폼 수수료 쉐어 선택"
                            value={platformCommissionOptions?.find(
                                (opt) => opt.value === formData?.member?.contractPartnerInfo?.platformCommissionShareRate
                            )}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    member: {
                                        ...prev.member,
                                        contractPartnerInfo: {
                                            ...prev.member.contractPartnerInfo,
                                            platformCommissionShareRate: option.value,
                                        },
                                    },
                                }));
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
